import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";
import { Reveal, SectionHeading } from "./Reveal";

export const FAQ_ITEMS = [
  {
    q: "How does booking and payment work?",
    a: "A 50% booking retainer is due at signing — your date is not reserved until payment clears. A further 25% is due 30 days before load-in, and the final 25% is due 7 days before load-in. Approved pass-through costs and overages are invoiced after the event.",
  },
  {
    q: "What if we need to cancel or reschedule?",
    a: "More than 60 days before load-in, we retain the booking retainer and any non-cancelable costs. At 31–60 days the cancellation fee is 75% of the total fee, and at 30 days or less it is 100%. Where possible, we credit a portion toward one rescheduled event within 12 months, subject to availability.",
  },
  {
    q: "What does our venue or booth need to provide?",
    a: "A level 10 ft x 10 ft operating area per simulator plus safe queue space, a dedicated 120V / 20-amp electrical outlet within 25 feet, and reliable internet if registration or lead capture is included. Credentials, dock and load-in access, parking, and venue-imposed costs such as electrical drops, drayage and union labor are handled by the exhibitor unless expressly included.",
  },
  {
    q: "Is the equipment secure overnight at multi-day shows?",
    a: "Multi-day pricing assumes the equipment remains assembled in a locked, access-controlled venue. Portable components can be removed each night, and if adequate security is not available we can remove and reinstall equipment daily as an additional service.",
  },
  {
    q: "Who operates the simulator during the event?",
    a: "Every activation includes a professional operator for up to 8 event hours per day. They handle participant onboarding, the fastest-lap competition, safety screening, and daily testing and calibration — your team does not need to manage the simulator.",
  },
  {
    q: "How do you handle participant safety?",
    a: "We operate with posted safety signage, participant screening and a short safety acknowledgment for every driver. Participants follow operator instructions and remain seated, and we may decline participation where safety or fit is a concern.",
  },
];

export const Faq = () => (
  <section id="faq" className="relative py-20 lg:py-28 border-t border-line" data-testid="faq-section">
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
      <SectionHeading
        center
        kicker="Booking Terms"
        title={
          <>
            Questions, <span className="text-electric">Answered.</span>
          </>
        }
        sub="The essentials from our event agreement — retainers, cancellations, and venue requirements."
      />

      <Reveal delay={0.15}>
        <Accordion type="single" collapsible className="mt-12" data-testid="faq-accordion">
          {FAQ_ITEMS.map((item, i) => (
            <AccordionItem
              key={item.q}
              value={`item-${i}`}
              className="border-line"
              data-testid={`faq-item-${i}`}
            >
              <AccordionTrigger
                className="font-display text-base sm:text-lg font-bold text-left text-slate-100 hover:text-electric hover:no-underline py-6 transition-colors"
                data-testid={`faq-trigger-${i}`}
              >
                {item.q}
              </AccordionTrigger>
              <AccordionContent className="text-sm text-slate-400 leading-relaxed pb-6">
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
